import { Component, inject, input } from '@angular/core';
import { DocumentPathService } from '@common';
import { IconComponent } from '../icon/icon.component';
import { LinkComponent } from '../link/link.component';

@Component({
  selector: 'app-terms-and-conditions-panel',
  templateUrl: './terms-and-conditions-panel.component.html',
  styleUrl: './terms-and-conditions-panel.component.scss',
  imports: [IconComponent, LinkComponent],
  standalone: true,
})
export class TermsAndConditionsPanelComponent {
  private readonly documentPathService = inject(DocumentPathService);

  readonly termsUrl = this.documentPathService.termsAndConditionsUrl;
  readonly ipidUrl = this.documentPathService.ipidUrl;
  readonly noPadding = input<boolean>(false);
  readonly toggleIcon = input<boolean>(true);
  readonly transparent = input<boolean>(false);
}
